export default __webpack_public_path__ + "static/media/mor-chaluz888.876ee3f0.png";